import React from 'react';

const AppFAQTutorial: React.FC = () => {
  return (
    <div className="accordion-container" style={{ backgroundColor: '#1a1a1a', padding: '30px', borderRadius: '8px', textAlign: 'justify', margin: '20px' }}>
      <h2 style={{ color: '#fff', textAlign: 'center', marginBottom: '20px' }}>Preguntas Frecuentes</h2>

      <h3 style={{ color: '#00aaff' }}>1. No recibí el token de actualización de contraseña. ¿Qué hago?</h3>
      <ul style={{ color: '#ccc' }}>
        <li>Verifica que el correo con el que estás solicitando el cambio corresponde a la cuenta con la que estás suscrito a TCS GO.</li>
        <li>Si corresponde, comunícate con nuestro equipo de soporte al <a href="https://wa.me/50369383613" style={{ color: '#00aaff' }}>https://wa.me/50369383613</a> para solicitar un cambio de contraseña manual.</li>
      </ul>

      <h3 style={{ color: '#00aaff' }}>2. Pagué mi suscripción y no se activó el servicio</h3>
      <p style={{ color: '#ccc' }}>Comprueba que tienes una suscripción activa según la plataforma:</p>
      <ul style={{ color: '#ccc' }}>
        <li><strong>Apple ID:</strong> Configuración → Apple ID → Suscripciones → TCS GO</li>
        <li><strong>Google Play Store:</strong> Pagos y Suscripciones → Suscripciones → TCS GO</li>
        <li><strong>TCSGO.com:</strong> Inicia sesión → Ícono de usuario → Pagos</li>
      </ul>

      <h3 style={{ color: '#00aaff' }}>3. ¿Cuáles son las formas de pago para suscribirme a TCS GO?</h3>
      <p style={{ color: '#ccc' }}>Vías oficiales:</p>
      <ul style={{ color: '#ccc' }}>
        <li><a href="https://www.tcsgo.com" style={{ color: '#00aaff' }}>www.tcsgo.com</a></li>
        <li>App TCS GO en iOS, tvOS, Android o Android TV</li>
      </ul>
      <p style={{ color: '#ccc' }}>Métodos de pago:</p>
      <ul style={{ color: '#ccc' }}>
        <li>Tarjetas de crédito o débito asociadas a tus dispositivos</li>
        <li>Tarjetas de crédito o débito en <a href="https://www.tcsgo.com" style={{ color: '#00aaff' }}>www.tcsgo.com</a></li>
      </ul>
      <p style={{ color: '#999' }}><em>A partir de agosto 2024, recibirás un correo con los detalles de la suscripción.</em></p>

      <h3 style={{ color: '#00aaff' }}>4. ¿Cómo puedo cancelar mi suscripción?</h3>
      <ul style={{ color: '#ccc' }}>
        <li><strong>iOS:</strong> Configuración → Apple ID → Suscripciones → TCS GO → Cancelar</li>
        <li><strong>Android:</strong> Pagos y Suscripciones → Suscripciones → TCS GO → Cancelar</li>
        <li><strong>TCSGO.com:</strong> Inicia sesión → Ícono de usuario → Pagos → Cancelar suscripción</li>
      </ul>
      <p style={{ color: '#ccc' }}>Si no puedes cancelarla, contacta a soporte y proporciona:</p>
      <ul style={{ color: '#ccc' }}>
        <li>Correo electrónico asociado</li>
        <li>Nombre completo</li>
        <li>Últimos 4 dígitos de tu tarjeta</li>
      </ul>

      <h3 style={{ color: '#00aaff' }}>5. ¿Cómo iniciar sesión en Smart TV?</h3>
      <ul style={{ color: '#ccc' }}>
        <li><strong>Apple TV:</strong> Descarga la app desde App Store, inicia sesión, escanea el código QR y accede con tus credenciales</li>
        <li><strong>Android TV:</strong> Descarga la app desde Google Play Store, inicia sesión, escanea el código QR y accede con tus credenciales</li>
      </ul>

      <h3 style={{ color: '#00aaff' }}>6. ¿Qué puedo ver en vivo en TCS GO?</h3>
      <ul style={{ color: '#ccc' }}>
        <li><strong>El Salvador:</strong> <a href="https://www.tcsahora.com/programacion-tv-tcs/" style={{ color: '#00aaff' }}>programación local</a></li>
        <li><strong>EE.UU. y resto del mundo:</strong> <a href="https://www.tcsgo.com" style={{ color: '#00aaff' }}>www.tcsgo.com</a></li>
      </ul>

      <h3 style={{ color: '#00aaff' }}>7. ¿Dónde puedo conocer la programación Deportiva de TCS GO?</h3>
      <ul style={{ color: '#ccc' }}>
        <li><strong>El Salvador:</strong> <a href="https://www.tcsahora.com/programacion-tv-tcs/" style={{ color: '#00aaff' }}>programación deportiva</a></li>
        <li><strong>EE.UU. y resto del mundo:</strong> redes sociales de TCS GO USA</li>
      </ul>

      <h3 style={{ color: '#00aaff' }}>8. No puedo ver un contenido</h3>
      <p style={{ color: '#ccc' }}>Repórtalo a nuestro equipo de soporte al <a href="https://wa.me/50369383613" style={{ color: '#00aaff' }}>https://wa.me/50369383613</a></p>

      <h3 style={{ color: '#00aaff' }}>9. Consulta no relacionada al servicio TCS GO</h3>
      <p style={{ color: '#ccc' }}>Escribe a <a href="mailto:info.mercadeo@tcs246.com" style={{ color: '#00aaff' }}>info.mercadeo@tcs246.com</a></p>
    </div>
  );
};

export default AppFAQTutorial;
